import * as React from 'react'

export default () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="9" r="8" stroke="#3C52EF" strokeWidth="1.5" />
    <path d="M9 5V13" stroke="#3C52EF" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M13 9L5 9" stroke="#3C52EF" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
)
